import AppContext from 'context/Context';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { FiAlertCircle, FiCheckCircle, FiUser } from 'react-icons/fi';
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
const LastSupportTickets = ({
    agentesSoporte,
    cargandoAgentesSoporte
}) => {
    const { setToken, token } = useToken();
    const { config } = useContext(AppContext);
    const { isDark } = config;
    const [tickets, setTickets] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [totalTickets, setTotalTickets] = useState(0);
    const [selectedUser, setSelectedUser] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const { showErrorToast } = useToast();

    // Skeleton Loading
    const TicketSkeleton = () => (
        <Row className="g-2 p-2">
            {[1, 2, 3, 4].map((i) => (
                <Col key={i} xs={12}>
                    <div style={{
                        padding: "12px",
                        border: "1px solid #e3e3e3",
                        borderRadius: "8px",
                        background: "transparent"
                    }}>
                        <Skeleton height={20} width="70%" className="mb-2" />
                        <Skeleton height={16} width="100%" className="mb-2" />
                        <Skeleton height={16} width="90%" className="mb-2" />
                        <Skeleton height={14} width="40%" />
                    </div>
                </Col>
            ))}
        </Row>
    );

    //obtiene la tabla de soporte tecnico
    const fetchMoreTickets = async (currentPage = page) => {
        try {
            const formattedDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1).toISOString().split('T')[0];

            const response = await fetch('/api/soportetecnico/GetLastMonthlyTickets', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    date: formattedDate,
                    idUsuario: selectedUser,
                    pagina: currentPage,
                    tamanioPagina: 5
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);

                    if (parsed.table3 && parsed.table3[0]) {
                        setTotalTickets(parsed.table3[0].totalTickets);
                    }

                    const nuevosTickets = parsed.table2;
                    if (nuevosTickets && nuevosTickets.length > 0) {
                        // Si es la primera p�gina, reemplazar en lugar de agregar
                        if (currentPage === 1) {
                            setTickets(nuevosTickets);
                        } else {
                            setTickets(prev => [...prev, ...nuevosTickets]);
                        }
                        setPage(currentPage + 1);

                        if (nuevosTickets.length < 5) {
                            setHasMore(false);
                        }
                    } else {
                        setHasMore(false);
                    }
                } else {
                    showErrorToast(data.vMessage);
                    setHasMore(false);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setHasMore(false);
            }
        } catch (error) {
            showErrorToast("Error inesperado al obtener tickets");
            setHasMore(false);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        if (selectedDate && selectedUser !== undefined && selectedUser !== null) {
            // Resetear estados cuando cambia el mes o usuario
            setTickets([]);
            setPage(1);
            setHasMore(true);
            setCargando(true);

            // Hacer la primera llamada
            fetchMoreTickets(1);
        }
    }, [selectedDate, selectedUser]);

    return (
        <Card>
            <Card.Header className="bg-light border-bottom px-4 py-3">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <i className="fas fa-ticket-alt me-2 text-primary"></i>
                        <h5 className="mb-0 fw-bold text-800">Últimos Tickets de Soporte</h5>
                        {tickets.length > 0 && (
                            <span className="badge bg-primary bg-opacity-10 text-primary ms-2 rounded-pill py-1 px-2 small">
                                {totalTickets}
                            </span>
                        )}
                    </div>
                    <div className="d-flex gap-2">
                        <Form.Select
                            size="sm"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.target.value === "" ? 0 : parseInt(e.target.value))}
                            style={{ minWidth: '150px' }}
                        >
                            <option value="">{cargandoAgentesSoporte ? 'Cargando agentes...' : 'Todos los agentes'}</option>
                            {agentesSoporte.map(agente => (
                                <option key={agente.idUsuario} value={agente.idUsuario}>
                                    {agente.vNombre} {agente.vApellidos}
                                </option>
                            ))}
                        </Form.Select>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => {
                                setSelectedDate(date);
                            }}
                            dateFormat="MMMM yyyy - QQQ"
                            className="form-control form-control-sm"
                            showMonthYearPicker
                            style={{ minWidth: '200px' }}
                        />
                    </div>
                </div>
            </Card.Header>
            <Card.Body className="p-2 overflow-x-hidden" id="scrollableTargetTickets" style={{ maxHeight: '600px', overflow: 'auto' }}>
                {cargando ? (
                    <TicketSkeleton />
                ) : (
                    <InfiniteScroll
                        dataLength={tickets.length}
                        next={fetchMoreTickets}
                        hasMore={hasMore}
                        key={`${selectedUser}-${selectedDate.getTime()}`}
                        loader={
                            <div className="d-flex justify-content-center align-items-center py-3">
                                <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                <span className="text-muted" style={{ fontSize: '0.85rem' }}>Cargando más tickets...</span>
                            </div>
                        }
                        scrollableTarget="scrollableTargetTickets"
                        scrollThreshold={0.95}
                        endMessage={
                            tickets.length > 0 && (
                                <div className="text-center py-3 border-top mt-2">
                                    <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                                        <FiCheckCircle className="me-1" size={12} />
                                        No hay más tickets
                                    </small>
                                </div>
                            )
                        }
                    >
                        {tickets.length === 0 ? (
                            <div className="text-center py-5">
                                <h6 className="text-muted mb-2">Sin tickets</h6>
                                <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                                    No hay tickets registrados para mostrar
                                </p>
                            </div>
                        ) : (
                            <Row className="g-2">
                                {tickets.map((ticket, index) => (
                                    <Col key={`${ticket.idTicketSoporte}-${index}`} xs={12}>
                                        <div style={{
                                            padding: "12px 16px",
                                            border: "1px solid #e3e3e3",
                                            borderRadius: "8px",
                                            background: "transparent",
                                            transition: "all 0.2s ease",
                                            cursor: "default",
                                            position: "relative"
                                        }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = "#0d6efd";
                                                e.currentTarget.style.boxShadow = "0 2px 8px rgba(13, 110, 253, 0.15)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = "#e3e3e3";
                                                e.currentTarget.style.boxShadow = "none";
                                            }}>
                                            {/* IP en esquina superior derecha */}
                                            {ticket.vIP && (
                                                <code style={{
                                                    position: "absolute",
                                                    top: "12px",
                                                    right: "16px",
                                                    fontSize: "0.7rem",
                                                    padding: "2px 6px",
                                                    background: isDark ? "#000" : "#f8f9fa",
                                                    borderRadius: "4px",
                                                    color: isDark ? "#f8f9fa" : "#6c757d"
                                                }}>
                                                    {ticket.vIP}
                                                </code>
                                            )}

                                            {/* Primera línea: Agente | Cliente | Fecha */}
                                            <div className="mb-2" style={{ paddingRight: "50px" }}>
                                                <FiUser size={14} className="text-primary me-1" style={{ verticalAlign: "middle" }} />
                                                <span className="fw-semibold text-800 me-2" style={{ fontSize: "0.85rem" }}>
                                                    {ticket.vNombre}
                                                </span>
                                                <span className="text-muted me-2">|</span>
                                                <Link
                                                    to={`/clientes/detalle/${ticket.idClienteAkasia}`}
                                                    className="text-decoration-none me-2"
                                                    style={{ fontSize: "0.85rem" }}
                                                >
                                                    {ticket.vNombreCliente}
                                                </Link>
                                                <span className="text-muted me-2">|</span>
                                                <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                                                    {new Date(ticket.dCreatedDate).toLocaleDateString('es-MX', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric'
                                                    }).replace('.', '')} {new Date(ticket.dCreatedDate).toLocaleTimeString('es-MX', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: true
                                                    })}
                                                </span>
                                            </div>

                                            {/* Problema */}
                                            <div className="mb-1">
                                                <FiAlertCircle size={13} className="text-warning me-1" style={{ verticalAlign: "middle" }} />
                                                <span className="fw-bold text-700" style={{ fontSize: "0.8rem" }}>Problema: </span>
                                                <span className="text-dark" style={{
                                                    fontSize: "0.8rem",
                                                    whiteSpace: "pre-wrap",
                                                    wordBreak: "break-word"
                                                }}>
                                                    {ticket.vProblema}
                                                </span>
                                            </div>

                                            {/* Solución */}
                                            {ticket.vSolucion && (
                                                <div>
                                                    <FiCheckCircle size={13} className="text-success me-1" style={{ verticalAlign: "middle" }} />
                                                    <span className="fw-bold text-700" style={{ fontSize: "0.8rem" }}>Solución: </span>
                                                    <span className="text-dark" style={{
                                                        fontSize: "0.8rem",
                                                        whiteSpace: "pre-wrap",
                                                        wordBreak: "break-word"
                                                    }}>
                                                        {ticket.vSolucion}
                                                    </span>
                                                </div>
                                            )}

                                            {/* Resolución */}
                                            {ticket.dFechaResolucion && (
                                                <div className="mt-1">
                                                    <FiCheckCircle size={13} className="text-info me-1" style={{ verticalAlign: "middle" }} />
                                                    <span className="text-700" style={{ fontSize: "0.8rem" }}>
                                                        Se resolvió el ticket en {ticket.dTiempo ? <span className="fw-bold ms-1 me-1">{ticket.dTiempo} minutos</span> : ''}el {new Date(ticket.dFechaResolucion).toLocaleDateString('es-MX', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        }).replace('.', '')} a las {new Date(ticket.dFechaResolucion).toLocaleTimeString('es-MX', {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })}  {ticket.vNombreNivel ? ' | ' : ''}{ticket.vNombreNivel && (
                                                            <>
                                                                {ticket.iNivel > 2 ? <span className="badge bg-danger">★ {ticket.iNivel}</span> : ticket.iNivel}
                                                                {' - ' + ticket.vNombreNivel}
                                                            </>
                                                        )}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        )}
                    </InfiniteScroll>
                )}
            </Card.Body>
            <Card.Footer>
                <div className="text-center text-muted">
                    {tickets.length} / {totalTickets} ticket{tickets.length !== 1 ? 's' : ''} cargado{tickets.length !== 1 ? 's' : ''}
                </div>
            </Card.Footer>
        </Card>
    )
}

LastSupportTickets.propTypes = {
    setMensajeError: PropTypes.func,
    setShowMensajeError: PropTypes.func,
    agentesSoporte: PropTypes.array,
    cargandoAgentesSoporte: PropTypes.bool
};


export default LastSupportTickets;
